import { render } from "./ProductImageCarousel.vue?vue&type=template&id=cf6a72c2"
import script from "./ProductImageCarousel.js?vue&type=script&lang=js&external"
export * from "./ProductImageCarousel.js?vue&type=script&lang=js&external"

import "./ProductImageCarousel.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__